import React, { useEffect, useState } from "react";
import {
  questionsDownloadHeader,
  questionsMasterHeader,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";
import * as XLSX from "sheetjs-style";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import TextArea from "../ReusableComponents/TextArea";
import TextEditor from "../ReusableComponents/TextEditor";
import QuestionsPopup from "../popup-containers/QuestionsPopup";
import Loader from "../ReusableComponents/Loader";

const Questions = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questionsValidationErrors, setQuestionsValidationErrors] = useState([
    "",
  ]);
  const [questionFields, setQuestionFields] = useState({
    module: "",
    topicNo: "",
    topic: "",
    questionsNo: "",
    version: "",
    attachment: 1,
    question: "",
    guidance: "",
    questionsBulkUpload: [],
  });

  const [questionFieldsError, setQuestionFieldsError] = useState({
    moduleError: "",
    topicNoError: "",
    topicError: "",
    questionNameError: "",
    questionNoError: "",
    questionsError: [],
    versionError: [],
    guidanceError: [],
  });

  const [moduleBindDD, setModuleBindDD] = useState([]);
  const [topicBind, setTopicBind] = useState([]);
  const [topicBindDD, setTopicBindDD] = useState([]);

  const handleQuestionFieldsChange = (value, name) => {
    setQuestionFields({
      ...questionFields,
      [name]: value,
    });
  };

  const [mstQuestionsId, setMstQuestionsId] = useState("");
  const [questionsDatas, setQuestionsDatas] = useState({});
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [questionsDropDownDatas, setQuestionsDropDownDatas] = useState({});

  // view details end

  const [bindQuestionsMasterDatas, setBindQuestionsMasterDatas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      bindDropDownDatas();
    };
    fetchData();
  }, []);

  const bindDropDownDatas = async () => {
    try {
      const response = await BindAPI("MasterDataAPI/BindMasterDatas");
      if (response.data.Table.length > 0) {
        const moduleDD = response.data.Table.map((m) => ({
          value: m.MstModuleId,
          label: m.ModuleName,
        }));
        setModuleBindDD(moduleDD);
      } else {
        setModuleBindDD([]);
      }
      if (response.data.Table1.length > 0) {
        setTopicBind(response.data.Table1);
      } else {
        setTopicBind([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  useEffect(() => {
    const moduleSelectedValue = topicBind.find(
      (item) => item.MstModuleId == questionFields.module
    );
    if (moduleSelectedValue) {
      const topicLabels = topicBind
        .filter((item) => item.MstModuleId === moduleSelectedValue.MstModuleId)
        .map((t) => ({
          value: t.MstTopicId,
          label: t.TopicName,
          no: t.TopicNo,
        }));
      setTopicBindDD(topicLabels);
    } else {
      setTopicBindDD([]);
    }
  }, [questionFields.module]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setQuestionFields({
      module: "",
      topicNo: "",
      topic: "",
      questionsNo: "",
      version: "",
      attachment: 1,
    });
    localStorage.setItem("screenMode", "add");
  };
  const fetchAnswerQuestions = async () => {
    try {
      setIsLoading(true);
      const { data } = await BindAPI("QuestionsAPI/BindQuestions");
      setBindQuestionsMasterDatas(data?.Table ?? []);
      if (data?.Table.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      } else {
        showAdd();
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchQuestionsNoId = async () => {
    if (editMode) return;
    if (!questionFields.topic) return;

    const data = {
      mstModuleId: questionFields.module,
      mstTopicId: questionFields.topic,
    };

    const response = await BindPostAPI([data], "QuestionsAPI/GetQuestionsId");
    const table = response.data?.Table;
    const baseQuestionNumber =
      table && table.length > 0
        ? table[0].QuestionNumber
        : `${questionFields.topicNo}.0`;

    const nextQuestionNumber = getIncrementedQuestionNumber(
      baseQuestionNumber,
      1
    );

    setQuestionFields({
      ...questionFields,
      questionsNo: nextQuestionNumber,
      questionsBulkUpload: [
        {
          questionNumber: nextQuestionNumber,
          version: "",
          question: "",
          guidance: "",
          attachment: 1,
        },
      ],
    });
  };

  useEffect(() => {
    fetchAnswerQuestions();
  }, []);
  useEffect(() => {
    fetchQuestionsNoId();
  }, [questionFields.topic]);

  const cancel = () => {
    setIsLoading(false);
    fetchAnswerQuestions();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSaveBtnDisabled(false);
    setSubmitVisibleButton(false);
    clear();
    localStorage.setItem("screenMode", "");
  };
  const clear = () => {
    setQuestionsValidationErrors("");
    setQuestionFields({
      module: "",
      topicNo: "",
      topic: "",
      questionsNo: "",
      version: "",
      attachment: 1,
    });
    setQuestionFieldsError({
      moduleError: "",
      topicNoError: "",
      topicError: "",
      questionNameError: "",
      questionNoError: "",
      questionsError: [],
      versionError: [],
      guidanceError: [],
    });
  };

  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex); // store index

    const data = bindQuestionsMasterDatas[rowIndex]; // safety
    if (!data) return;

    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    setQuestionFields({
      ...questionFields,
      module: data.MstModuleId,
      topic: data.MstTopicId,
      topicNo: data.TopicNumber,
      questionsBulkUpload: [
        {
          questionNumber: data.QuestionNumber,
          version: data.Version,
          question: data.Question,
          guidance: data.Guidance,
          attachment: data.AttachmentMandatoryYN,
          questionChildId: data.MstQuestionsChildId,
        },
      ],
    });
    setMstQuestionsId(data.MstQuestionsId);
  };

  const handleQuestions = (rowIndex, flag) => {
    // Setting visibility in popup container
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setQuestionsDatas(bindQuestionsMasterDatas[rowIndex]);
    setQuestionFields({
      ...questionFields,
      module: bindQuestionsMasterDatas[rowIndex].MstModuleId,
      topic: bindQuestionsMasterDatas[rowIndex].MstTopicId,
      topicNo: bindQuestionsMasterDatas[rowIndex].TopicNumber,
      questionsBulkUpload: [
        {
          questionNumber: bindQuestionsMasterDatas[rowIndex].QuestionNumber,
          version: bindQuestionsMasterDatas[rowIndex].Version,
          question: bindQuestionsMasterDatas[rowIndex].Question,
          guidance: bindQuestionsMasterDatas[rowIndex].Guidance,
          attachment: bindQuestionsMasterDatas[rowIndex].AttachmentMandatoryYN,
          questionChildId:
            bindQuestionsMasterDatas[rowIndex].MstQuestionsChildId,
        },
      ],
    });
    const moduleRowData = bindQuestionsMasterDatas[rowIndex];
    const moduleInfo = moduleBindDD.find(
      (ST) => ST.value === moduleRowData.MstModuleId
    );
    const resultModule = {
      value: moduleRowData.MstModuleId,
      label: moduleInfo ? moduleInfo.label : "",
    };

    const topicRowData = bindQuestionsMasterDatas[rowIndex];
    const topicInfo = topicBind.find(
      (ST) => ST.MstTopicId === topicRowData.MstTopicId
    );
    const resultTopic = {
      value: topicRowData.MstTopicId,
      label: topicInfo ? topicInfo.TopicName : "",
    };
    const DropDownDatas = [resultModule, resultTopic];

    setQuestionsDropDownDatas(DropDownDatas);
  };

  const createdBy = sessionStorage.getItem("createdBy");

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const plainText = (
        questionFields.questionsBulkUpload?.[0]?.guidance || ""
      )
        .replace(/<(.|\n)*?>/g, "")
        .trim();

      const isFormError = {
        ...questionFieldsError,
        moduleError: questionFields.module ? "" : "Select Module",
        topicError: questionFields.topic ? "" : "Select Topic",
        topicNoError: questionFields.topicNo ? "" : "Select Topic No.",
        questionNoError:
          updateScreenTitle || questionFields.questionsNo
            ? ""
            : "Enter Questions No.",
        versionError: questionFields.questionsBulkUpload?.[0]?.version
          // ? /^[a-zA-Z0-9.-]+$/.test(
          //   questionFields.questionsBulkUpload[0].version
          // )
            ? ""
            // : "Invalid format: Use only letters, numbers, '.', and '-'"
          : "Enter Version",
        questionsError:
          questionFields.questionsBulkUpload?.[0]?.question &&
            questionFields.questionsBulkUpload?.[0]?.question.trim() !== ""
            ? ""
            : "Enter Question",
        guidanceError: plainText.length > 0 ? "" : "Enter Guidance",
      };
      setQuestionFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const questionsPayload = [
          {
            mstQuestionsId: mstQuestionsId ? mstQuestionsId : 0,
            mstModuleId: questionFields.module,
            mstTopicId: questionFields.topic,
            topicNumber: questionFields.topicNo,
            questionsBulkUpload: JSON.stringify(
              questionFields.questionsBulkUpload
            ),
            createdby: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          questionsPayload,
          "QuestionsAPI/IUDQuestions"
        );
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("Questions Added Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Add Questions Data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Questions Updated Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Update Questions Data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      const data = {
        mstQuestionsId: bindQuestionsMasterDatas[items].MstQuestionsId,
        mstModuleId: questionFields.module,
        mstTopicId: questionFields.topic,
        topicNumber: questionFields.topicNo,
        questionsBulkUpload: JSON.stringify(questionFields.questionsBulkUpload),
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "QuestionsAPI/IUDQuestions");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Questions Data Deleted Successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed To Delete Questions Data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Questions Data Active Successfully 🚫",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed To Active Questions Data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Questions Data Inactive Successfully ✅",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed To Inactive Questions Data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };
  const handleSave = async (e, flag) => {
    e.preventDefault();
    setSubmitBtnDisabled(true);
    setSaveBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const plainText = (
        questionFields.questionsBulkUpload?.[0]?.guidance || ""
      )
        .replace(/<(.|\n)*?>/g, "")
        .trim();

      const isFormError = {
        ...questionFieldsError,
        moduleError: questionFields.module ? "" : "Select Module",
        topicError: questionFields.topic ? "" : "Select Topic",
        topicNoError: questionFields.topicNo ? "" : "Select Topic No.",
        questionNoError:
          updateScreenTitle || questionFields.questionsNo
            ? ""
            : "Enter Questions No.",
        versionError: questionFields.questionsBulkUpload?.[0]?.version
          ? /^[a-zA-Z0-9.-]+$/.test(
            questionFields.questionsBulkUpload[0].version
          )
            ? ""
            : "Invalid format: Use only letters, numbers, '.', and '-'"
          : "Enter Version",
        questionsError:
          questionFields.questionsBulkUpload?.[0]?.question &&
            questionFields.questionsBulkUpload?.[0]?.question.trim() !== ""
            ? ""
            : "Enter Question",
        guidanceError: plainText.length > 0 ? "" : "Enter Guidance",
      };

      setQuestionFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (!isFormValid) {
        setSaveBtnDisabled(false);
        setSubmitBtnDisabled(false);
        return; // Prevent popup close or submission
      }
      if (isFormValid) {
        setIsLoading(true);
        setSaveBtnDisabled(true);
        setSubmitBtnDisabled(true);
        const questionsPayload = [
          {
            mstQuestionsId: mstQuestionsId ? mstQuestionsId : 0,
            mstModuleId: questionFields.module,
            mstTopicId: questionFields.topic,
            topicNumber: questionFields.topicNo,
            questionsBulkUpload: JSON.stringify(
              questionFields.questionsBulkUpload
            ),
            createdby: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(
          questionsPayload,
          "QuestionsAPI/IUDQuestions"
        );
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].Result === "S") {
            toast.success("Question Saved Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setIsLoading(false);
            fetchQuestionsNoId();
            setQuestionFields({
              questionsNo: "",
              version: "",
              question: "",
              guidance: "",
              questionsBulkUpload: [
                {
                  questionNumber: "",
                  version: "",
                  question: "",
                  guidance: "",
                  attachment: 0,
                },
              ],
            });
            setSaveBtnDisabled(false);
            setSubmitBtnDisabled(false);
          } else {
            toast.error("Failed To Save Question Data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSaveBtnDisabled(false);
        setIsOpen(true);
      }
    }
  };
  useEffect(() => {
    if (location.pathname === "/questions") {
      const screenMode = localStorage.getItem("screenMode");

      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
        setQuestionFields({
          module: "",
          topicNo: "",
          topic: "",
          questionsNo: "",
          version: "",
          attachment: 1,
        });
      } else if (screenMode === "edit") {
        bindDropDownDatas();
        fetchAnswerQuestions();

        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindQuestionsMasterDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindQuestionsMasterDatas]);

  const addAnswerInput = () => {
    setQuestionFields((prev) => {
      const existing = Array.isArray(prev.questionsBulkUpload)
        ? [...prev.questionsBulkUpload]
        : [];

      // Get the next index and question number
      const nextIndex = existing.length;
      const nextQuestionNumber = getIncrementedQuestionNumber(
        prev.questionsNo,
        nextIndex
      );

      // Create the new answer object
      const newAnswer = {
        questionNumber: nextQuestionNumber,
        version: "",
        question: "",
        guidance: "",
        attachment: 1,
      };

      // Update the state with the new object added
      return {
        ...prev,
        questionsBulkUpload: [...existing, newAnswer],
      };
    });

    setQuestionsValidationErrors((prev) => [...prev, {}]);
  };

  const removeAnswerInput = (indexToRemove) => {
    setQuestionFields((prev) => {
      const bulkUpload = Array.isArray(prev.questionsBulkUpload)
        ? prev.questionsBulkUpload
        : [];

      // Prevent deletion if there's only one item
      if (bulkUpload.length <= 1) {
        return prev; // Do nothing
      }

      const updated = bulkUpload.filter((_, i) => i !== indexToRemove);
      const reIndexed = updated.map((item, i) => ({
        ...item,
        questionNumber: getIncrementedQuestionNumber(prev.questionsNo, i),
      }));
      return { ...prev, questionsBulkUpload: reIndexed };
    });

    setQuestionsValidationErrors((prev) => {
      const validPrev = Array.isArray(prev) ? prev : [];
      return validPrev.length <= 1
        ? validPrev // Keep existing error if only one row
        : validPrev.filter((_, i) => i !== indexToRemove);
    });
  };

  const getIncrementedQuestionNumber = (base, index) => {
    if (!base) return "";
    const parts = base.split(".");
    if (parts.length !== 2) return base;

    const prefix = parts[0];
    const number = parseInt(parts[1], 10);

    return isNaN(number) ? base : `${prefix}.${number + index}`;
  };

  const handleAnswerChange = (index, key, value) => {
    setQuestionFields((prev) => {
      const updated = [...(prev.questionsBulkUpload || [])];
      if (!updated[index]) {
        updated[index] = {
          questionNumber: getIncrementedQuestionNumber(prev.questionsNo, index),
          version: "",
          question: "",
          guidance: "",
          attachment: 1,
        };
      }
      updated[index][key] = value;
      return { ...prev, questionsBulkUpload: updated };
    });
  };

  const handleExport = () => {
    exportData(
      questionsDownloadHeader.map((column) => column.title),
      bindQuestionsMasterDatas
    );
  };

  const exportData = (columns, rows) => {
    const titleRow = [
      {
        v: "Questions",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "000000" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ModuleName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TopicName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.QuestionNumber,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Question,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Guidance.replace(/<[^>]*>/g, "").trim(),
          s: {
            ...baseStyle,
            alignment: { horizontal: "left", wrapText: true },
          },
        },
      ];
    });

    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Dynamically calculate column widths
    const getMaxColumnWidths = (data) => {
      const colCount = data[2].length; // assuming header row has all columns
      const colWidths = [];

      for (let col = 0; col < colCount; col++) {
        let maxLen = data.reduce((max, row) => {
          const cell = row[col];
          const len = cell?.v ? cell.v.toString().length : 0;
          return Math.max(max, len);
        }, 10); // minimum width
        colWidths.push({ width: maxLen + 2 }); // padding
      }

      return colWidths;
    };
    const guidanceMaxWidth = Math.min(
      Math.max(
        ...rows.map(
          (r) => (r.Guidance?.replace(/<[^>]*>/g, "").length || 0) / 1.5
        )
      ),
      96
    );
    ws["!cols"] = [
      { width: 8 },
      { width: 18 },
      { width: 30 },
      { width: 40 },
      { width: 15 },
      { width: 96 },
      { width: guidanceMaxWidth }, // dynamic width with cap
    ];

    // Set row heights
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    // Apply borders
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Questions.xlsx");
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading && (
        <GridPage
          title="Questions Master"
          header={questionsMasterHeader}
          records={bindQuestionsMasterDatas}
          blockView={true}
          downloadView={true}
          handleExport={handleExport}
          handleEdit={handleEdit}
          handleAction={handleQuestions}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Questions Master"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class="grid gap-4 mb-2 md:grid-cols-4">
                    <AutoDropDown
                      title="Module"
                      options={moduleBindDD}
                      placeholder="Select"
                      name="module"
                      disabled={updateScreenTitle}
                      selectedOption={moduleBindDD.find(
                        (x) => x.value == questionFields.module
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleQuestionFieldsChange(value.value, e.name);
                        setQuestionFields({
                          ...questionFields,
                          module: value.value,
                          topic: "",
                          topicNo: "",
                          questionsNo: "",
                          questionsBulkUpload: [
                            {
                              questionNumber: "",
                              version: "",
                              question: "",
                              guidance: "",
                              attachment: 0,
                            },
                          ],
                        });
                        setQuestionFieldsError({
                          ...questionFieldsError,
                          moduleError: value ? "" : "Select Module",
                        });
                      }}
                      controlFuncBlur={() => {
                        setQuestionFieldsError(() => ({
                          ...questionFieldsError,
                          moduleError: questionFields.module
                            ? ""
                            : "Select Module",
                        }));
                      }}
                      errorMessage={questionFieldsError.moduleError}
                    />

                    <div class="sm:col-span-2">
                      <AutoDropDown
                        title="Topic"
                        options={topicBindDD}
                        placeholder="Select"
                        name="topic"
                        disabled={updateScreenTitle}
                        selectedOption={
                          questionFields.topic
                            ? topicBindDD.find(
                              (x) => x.value == questionFields.topic
                            )
                            : ""
                        }
                        Class="custom-class"
                        tabIndex="1"
                        classStar="text-red-500"
                        controlFunc={(value, e) => {
                          handleQuestionFieldsChange(value.value, e.name);
                          setQuestionFields({
                            ...questionFields,
                            topic: value.value,
                            topicNo: value.no,
                          });
                          setQuestionFieldsError({
                            ...questionFieldsError,
                            topicError: value ? "" : "Select Topic",
                          });
                        }}
                        controlFuncBlur={() => {
                          setQuestionFieldsError(() => ({
                            ...questionFieldsError,
                            topicError: questionFields.topic
                              ? ""
                              : "Select Topic",
                          }));
                        }}
                        errorMessage={questionFieldsError.topicError}
                      />
                    </div>
                    <InputText
                      inputType={"text"}
                      title="Topic No."
                      name={"topicNo"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      disabled={true}
                      content={questionFields.topicNo}
                      errorMessage={questionFieldsError.topicNoError}
                    />
                  </div>
                  <div className="">
                    {(questionFields.questionsBulkUpload || [""]).map((answer, index) => (
                      <div
                        key={index}
                        className="mb-4 border border-gray-300 p-4 rounded relative"
                      >
                        {/* Top-right icons */}
                        {addScreenTitle && (
                          <div className="absolute top-2 right-2 flex flex-row items-center space-x-2">
                            {/* Add Button */}
                            <svg
                              viewBox="0 0 1024 1024"
                              fill="currentColor"
                              onClick={addAnswerInput}
                              className="w-5 h-5 text-black cursor-pointer"
                              role="button"
                            >
                              <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                            </svg>
                            {/* Remove Button */}
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              onClick={() => removeAnswerInput(index)}
                              className="w-5 h-5 text-black cursor-pointer"
                              role="button"
                            >
                              <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                            </svg>
                          </div>
                        )}

                        {/* Additional Fields */}
                        <div className={mainTable.grid2}>
                          <InputText
                            inputType={"text"}
                            title={"Question No."}
                            name={"questionsNo"}
                            classStar={"text-red-500"}
                            maxLength={100}
                            disabled={true}
                            controlFuncBlur={() => {
                              setQuestionFieldsError(() => ({
                                ...questionFieldsError,
                                questionNoError: answer.questionNumber
                                  ? ""
                                  : "Enter Question No.",
                              }));
                            }}
                            errorMessage={questionFieldsError.questionNoError}
                            content={answer.questionNumber || questionFields.questionsNo}
                          />

                          <InputText
                            inputType={"text"}
                            title={"Version"}
                            name={"version"}
                            classStar={"text-red-500"}
                            maxLength={20}
                            content={answer.version}
                            controlFunc={(e) => {
                              handleAnswerChange(index, "version", e.target.value);
                            }}
                            controlFuncBlur={() => {
                              const regex = /^[a-zA-Z0-9.-]+$/;
                              setQuestionFieldsError(() => ({
                                ...questionFieldsError,
                                versionError: !answer.version
                                  ? "Enter Version"
                                  // : !regex.test(answer.version)
                                  //   ? "Invalid format: Only letters, numbers, '.', and '-' allowed"
                                    : "",
                              }));
                            }}
                            errorMessage={questionFieldsError.versionError}
                          />
                        </div>

                        <div className="mt-4">
                          <TextArea
                            title={`Question`}
                            name={`answer${index}`}
                            classStar={"text-red-500"}
                            maxLength={500}
                            content={answer.question}
                            controlFunc={(e) => {
                              handleAnswerChange(index, "question", e.target.value);
                            }}
                            controlFuncBlur={() => {
                              setQuestionFieldsError(() => ({
                                ...questionFieldsError,
                                questionsError: answer.question ? "" : "Enter Question",
                              }));
                            }}
                            errorMessage={questionFieldsError.questionsError}
                          />
                        </div>

                        {/* Guidance */}
                        <div className="mt-2">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Guidance<span className={"text-red-500"}>*</span>
                          </label>
                          <TextEditor
                            value={answer.guidance || ""}
                            onChange={(value) => {
                              const plainText = value.replace(/<(.|\n)*?>/g, "").trim();
                              handleAnswerChange(index, "guidance", value);
                              setQuestionFieldsError((prev) => ({
                                ...prev,
                                guidanceError: plainText.length > 0
                                  ? ""
                                  : prev.guidanceError,
                              }));
                            }}
                            onBlur={({ target }) => {
                              const plainText = target.value.replace(/<(.|\n)*?>/g, "").trim();
                              setQuestionFieldsError((prev) => ({
                                ...prev,
                                guidanceError: plainText.length > 0
                                  ? ""
                                  : "Enter Guidance",
                              }));
                            }}
                            error={questionFieldsError.guidanceError}
                          />
                        </div>

                        {addScreenTitle && (
                          <div className="mt-2 ml-6 space-y-2 flex justify-end">
                            <button
                              disabled={saveBtnDisabled}
                              onClick={(e) => handleSave(e, 1)}
                              className="bg-gray-600 text-white px-4 py-1 rounded hover:bg-gray-700"
                            >
                              Save
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* <div className="">
                    {(questionFields.questionsBulkUpload || [""]).map(
                      (answer, index) => (
                        <div
                          key={index}
                          className="mb-4 border border-gray-300 p-4 rounded relative"
                        >

                          {addScreenTitle && (
                            <div className="absolute top-2 right-2 flex flex-row items-center space-x-2">

                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={addAnswerInput}
                                className="w-5 h-5 text-black cursor-pointer"
                                role="button"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>

                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                onClick={() => removeAnswerInput(index)}
                                className="w-5 h-5 text-black cursor-pointer"
                                role="button"
                              >
                                <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                              </svg>
                            </div>
                          )}


                          <div className={mainTable.grid2}>
                            <InputText
                              inputType={"text"}
                              title={"Question No."}
                              name={"questionsNo"}
                              classStar={"text-red-500"}
                              maxLength={100}
                              disabled={true}
                              controlFuncBlur={() => {
                                setQuestionFieldsError(() => ({
                                  ...questionFieldsError,
                                  questionNoError: answer.questionNumber
                                    ? ""
                                    : "Enter Question No.",
                                }));
                              }}
                              errorMessage={questionFieldsError.questionNoError}
                              content={
                                answer.questionNumber ||
                                questionFields.questionsNo
                              }
                            />

                            <InputText
                              inputType={"text"}
                              title={"Version"}
                              name={"version"}
                              classStar={"text-red-500"}
                              maxLength={20}
                              content={answer.version}
                              controlFunc={(e) => {
                                handleAnswerChange(
                                  index,
                                  "version",
                                  e.target.value
                                );
                                setQuestionFields({
                                  ...questionFields,
                                  version: e.target.value,
                                });
                              }}
                              controlFuncBlur={() => {
                                const regex = /^[a-zA-Z0-9.-]+$/;
                                setQuestionFieldsError(() => ({
                                  ...questionFieldsError,
                                  versionError: !answer.version
                                    ? "Enter Version"
                                    : !regex.test(answer.version)
                                      ? "Invalid format: Only letters, numbers, '.', and '-' allowed"
                                      : "",
                                }));
                              }}
                              errorMessage={questionFieldsError.versionError}
                            />
                          </div>

                          <div className="mt-4">
                            <TextArea
                              title={`Question`}
                              name={`answer${index}`}
                              classStar={"text-red-500"}
                              maxLength={500}
                              content={answer.question}
                              controlFunc={(e) => {
                                handleAnswerChange(
                                  index,
                                  "question",
                                  e.target.value
                                );
                                setQuestionFields({
                                  ...questionFields,
                                  question: e.target.value,
                                });
                              }}
                              controlFuncBlur={() => {
                                setQuestionFieldsError(() => ({
                                  ...questionFieldsError,
                                  questionsError: answer.question
                                    ? ""
                                    : "Enter Question",
                                }));
                              }}
                              errorMessage={questionFieldsError.questionsError}
                            />
                          </div>


                          <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Guidance<span className={"text-red-500"}>*</span>
                            </label>
                            <TextEditor
                              value={answer.guidance || ""}
                              onChange={(value) => {
                                const plainText = value
                                  .replace(/<(.|\n)*?>/g, "")
                                  .trim();
                                handleAnswerChange(index, "guidance", value);
                                setQuestionFields((prev) => ({
                                  ...prev,
                                  guidance: value,
                                }));
                                setQuestionFieldsError((prev) => ({
                                  ...prev,
                                  guidanceError:
                                    plainText.length > 0
                                      ? ""
                                      : prev.guidanceError,
                                }));
                              }}
                              onBlur={({ target }) => {
                                const plainText = target.value
                                  .replace(/<(.|\n)*?>/g, "")
                                  .trim();
                                setQuestionFieldsError((prev) => ({
                                  ...prev,
                                  guidanceError:
                                    plainText.length > 0
                                      ? ""
                                      : "Enter Guidance",
                                }));
                              }}
                              error={questionFieldsError.guidanceError}
                            />
                          </div>
                          {addScreenTitle && (
                            <div className="mt-2 ml-6 space-y-2 flex justify-end">
                              <button
                                disabled={saveBtnDisabled}
                                onClick={(e) => handleSave(e, 1)}
                                className="bg-gray-600 text-white px-4 py-1 rounded hover:bg-gray-700"
                              >
                                Save
                              </button>
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div> */}
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Questions Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <QuestionsPopup
            data={questionsDatas}
            data1={questionsDropDownDatas}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Questions;
